import React, { useEffect, useState } from 'react';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalHeader, UncontrolledDropdown } from 'reactstrap';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../../Component';
import { useDispatch } from 'react-redux';
import * as app_consts from "../../../utils/app_consts";
import { TENANT_RETRIEVE_PROMOTION_DRAW_DETAILS_API } from '../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_promotion_draw_details, loading_retrieve_promotion_draw_details, reset_retrieve_promotion_draw_details, success_retrieve_promotion_draw_details } from '../../../reducers/auth_tenant/retrieve_promotion_draw_details_Slice';
import { RETRIEVE_PROMOTION_DRAW_DETAILS_ERROR_MSG, RETRIEVE_PROMOTION_DRAW_DETAILS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { formatToSentenceCase, messageToast } from '../../../utils/Utils';
import CardTabs from '../../../pages/components/cards/CardTabs';
import moment from 'moment';
import FeatureUnderDevelopment from '../../../pages/loaders/FeatureUnderDevelopment';
import AuthTenantNoData from '../../../pages/error/AuthTenantNoData';
import AuthTenantLoader from '../../../pages/loaders/AuthTenantLoader';
import InitiatePromotionDrawModal from './InitiatePromotionDrawModal';
import { download, generateCsv, mkConfig } from 'export-to-csv';

const ViewPromotionDrawDetailsModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [sent_data, setSentData] = useState(data);
  const [page_data, setPageData] = useState([]);
  const [activeCardTab, setActiveCardTab] = useState("Main Details");
  const [participantItemsPerPage] = useState(50);
  const [currentParticipantItemsPage, setCurrentParticipantPage] = useState(1);
  const [sm, updateSm] = useState(false);
  const [initiate_promotion_draw_modal, setInitiatePromotionDrawModal] = useState(false);

  // Card Tabs
  const view_goods_received_details_tabs = [
    {
      tabName: "Main Details"
    },
    {
      tabName: "Participants"
    },
    {
      tabName: "Rules"
    },
    {
      tabName: "Prize Winners"
    }
  ];

  useEffect(() => {
    setError("");
    setSentData(data);
    setOpen(isOpen);

    if (isOpen && data)
    {
      retrieve_data(data);
    }
  }, [isOpen, data]);

  const retrieve_data = (id) => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_promotion_draw_details, success_retrieve_promotion_draw_details, fail_retrieve_promotion_draw_details, RETRIEVE_PROMOTION_DRAW_DETAILS_ERROR_MSG, RETRIEVE_PROMOTION_DRAW_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_DRAW_DETAILS_API}/${id}`));
  };

  // Listener
  const retrieve_promotion_draw_details_listener = useSelector((state) => state.retrieve_promotion_draw_details.retrieve_promotion_draw_details);

  useEffect(() => {
    if (retrieve_promotion_draw_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_promotion_draw_details_listener.status === app_consts.LOADING && !initiate_promotion_draw_modal)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_promotion_draw_details_listener.status === app_consts.FAIL && !initiate_promotion_draw_modal)
        {
          setLoading(false);
          setError(retrieve_promotion_draw_details_listener.message);
          messageToast(retrieve_promotion_draw_details_listener.message, app_consts.FAIL);
        } else if (retrieve_promotion_draw_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_promotion_draw_details_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_promotion_draw_details());
      }
    }
  }, [retrieve_promotion_draw_details_listener]);

  const paginate = (pageNumber) => setCurrentParticipantPage(pageNumber);

  const indexOfLastParticipantItem = currentParticipantItemsPage * participantItemsPerPage;
  const indexOfFirstParticipantItem = indexOfLastParticipantItem - participantItemsPerPage;
  const currentParticipantItems = page_data?.participants?.slice(indexOfFirstParticipantItem, indexOfLastParticipantItem);

  const open_initiate_promotion_draw_modal = () => {
    setInitiatePromotionDrawModal(true);
  };

  const close_initiate_promotion_draw_modal = () => {
    setInitiatePromotionDrawModal(false);
  };

  const initiate_promotion_draw_modal_successFunciton = () => {
    retrieve_data(sent_data);
  };

  const export_prize_winners_to_csv = async (e) => {
    e.preventDefault();
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    // Headers
    const csv_headers = ["Rank", "Prize", "Name", "Gender", "Mobile_number", "Location", "Place", "Code", "Status", "Entry Date"];

    const csv_data = page_data?.winners?.map((item) => {
      return {
        rank: item?.promotion_draw_winner?.rank,
        prize: item?.promotion_draw_winner?.prize,
        name: `${item?.participant?.first_name} ${item?.participant?.middle_name ? item?.participant?.middle_name : ""} ${item?.participant?.last_name}`,
        gender: item?.participant?.gender,
        mobile_number: item?.participant?.mobile_number,
        location: item?.promotion_participant?.location,
        place: item?.promotion_participant?.place,
        code: item?.promotion_participant?.entry_code,
        status: item?.promotion_participant?.code_status,
        entry_date: item?.promotion_participant?.inserted_at ? moment(item?.promotion_participant?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "",
      };
    });

    const options = mkConfig({
      fieldSeparator: ',',
      quoteStrings: '"',
      showLabels: true,
      showTitle: false,
      title: " ",
      useTextFile: false,
      useBom: true,
      filename: `Prize Winners - Generated on ${cur_dt}`,
      useKeysAsHeaders: true,
      columnHeaders: csv_headers,
    });

    const csv = generateCsv(options)(csv_data || []);

    download(options)(csv);

  };


  return (
    <>
      < Modal isOpen={open} className="modal-dialog-centered" size={"lg"} fullscreen >
        <ModalHeader toggle={!(loading) ? () => {
          successFunction();
          closeModal();
        } : undefined}>Promotion Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Promotion Draw Details..." />
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 16, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        <Block>
                          <BlockHead size="sm">
                            <BlockBetween className="g-3">
                              <BlockHeadContent>
                                <div className="toggle-wrap nk-block-tools-toggle">
                                  <Button
                                    className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                                    onClick={() => updateSm(!sm)}
                                  >
                                    <Icon name="menu-alt-r"></Icon>
                                  </Button>
                                  <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                                    <ul className="nk-block-tools g-3">
                                      <li>
                                        <UncontrolledDropdown>
                                          <DropdownToggle tag="a" className="dropdown-toggle btn btn-white btn-dim btn-outline-light mt-2">
                                            <span>Actions</span>
                                            <Icon name="chevron-right" className="dd-indc"></Icon>
                                          </DropdownToggle>
                                          <DropdownMenu end>
                                            <ul className="link-list-opt no-bdr">
                                              {
                                                (page_data?.draw?.status === app_consts.PENDING || page_data?.draw?.status === app_consts.IN_DRAW) && (user_info?.roles?.includes(app_consts.INITIATE_PROMOTION_DRAW) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                                  <>
                                                    <li>
                                                      <DropdownItem
                                                        tag="a"
                                                        href="#dropdownitem"
                                                        onClick={(ev) => {
                                                          ev.preventDefault();
                                                          setActiveCardTab("Prize Winners");
                                                          open_initiate_promotion_draw_modal();
                                                        }}
                                                      >
                                                        <span>Initiate Promotion Draw </span>
                                                      </DropdownItem>
                                                    </li>
                                                  </>
                                                )
                                              }
                                            </ul>
                                          </DropdownMenu>
                                        </UncontrolledDropdown>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </BlockHeadContent>
                            </BlockBetween>
                          </BlockHead>
                          <CardTabs cardTabs={view_goods_received_details_tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                        </Block>
                        {
                          activeCardTab === "Main Details" && (
                            <>
                              <div className="card-inner bg-white">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Main Details</BlockTitle>
                                  </BlockHead>
                                  <div className="profile-ud-list">
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Draw Type</span>
                                        <span className="profile-ud-value">{page_data?.draw?.draw_type?.replace(/_/g, ' ').toUpperCase() || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Draw Date</span>
                                        <span className="profile-ud-value">{page_data?.draw?.draw_at ? moment(page_data?.draw?.draw_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Participant Date Start</span>
                                        <span className="profile-ud-value">{page_data?.draw?.participant_date_start ? moment(page_data?.draw?.participant_date_start).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Participant Date End</span>
                                        <span className="profile-ud-value">{page_data?.draw?.participant_date_end ? moment(page_data?.draw?.participant_date_end).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Active Participants</span>
                                        <span className="profile-ud-value">{page_data?.participants?.length || "--"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Status</span>
                                        <span className="profile-ud-value">
                                          <span className="tb-odr-status">
                                            <Badge
                                              color={
                                                page_data?.draw?.status === app_consts.ACTIVE
                                                  ? "success"
                                                  : "warning"
                                              }
                                              className="badge-dot"
                                            >
                                              {page_data?.draw?.status ? formatToSentenceCase(page_data?.draw?.status)?.toUpperCase() : "--"}
                                            </Badge>
                                          </span></span>
                                      </div>
                                    </div>
                                  </div>
                                </Block>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Participants" && (
                            <>
                              <div className="card-inner bg-white">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Participants</BlockTitle>
                                  </BlockHead>
                                  <div className="nk-tb-list is-separate is-medium mb-3">
                                    <DataTableHead className="nk-tb-item">
                                      <DataTableRow>
                                        <span className="sub-text">Name</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="sub-text">Contact</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="sub-text">Code</span>
                                      </DataTableRow>
                                      <DataTableRow size="lg">
                                        <span className="sub-text">Place/Location</span>
                                      </DataTableRow>
                                      <DataTableRow size="lg">
                                        <span className="sub-text">Gender</span>
                                      </DataTableRow>
                                      <DataTableRow size="lg">
                                        <span className="sub-text">Entry Date</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span className="sub-text">Status</span>
                                      </DataTableRow>
                                      <DataTableRow size="md">
                                        <span className="sub-text">Action</span>
                                      </DataTableRow>
                                    </DataTableHead>
                                    {/*Head*/}
                                    {currentParticipantItems?.length > 0
                                      ? currentParticipantItems?.map((item) => (
                                        <DataTableItem key={item.id}>
                                          <DataTableRow>
                                            <span className="tb-product">
                                              <span className="tb-sub">{item?.participant?.first_name ? `${item?.participant?.first_name} ${item?.participant?.middle_name ? item?.participant?.middle_name : ""} ${item?.participant?.last_name ? item?.participant?.last_name : ""}` : "--"}</span>
                                            </span>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  {item?.participant?.mobile_number || "--"}
                                                </span>
                                                <span>MNO | {item?.participant?.mobile_network_provider?.replace(/_/g, ' ').toUpperCase() || "--"}</span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">{item?.promotion_participant?.entry_code}</span>
                                                <span>
                                                  <Badge
                                                    color={
                                                      item?.promotion_participant?.code_status === app_consts.VALID
                                                        ? "success"
                                                        : "warning"
                                                    }
                                                    className="badge-dot"
                                                  >
                                                    {item?.promotion_participant?.code_status ? formatToSentenceCase(item?.promotion_participant?.code_status)?.toUpperCase() : "--"}
                                                  </Badge>
                                                </span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  {item?.promotion_participant?.place || "--"}
                                                </span>
                                                <span>{item?.promotion_participant?.location || "--"}</span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  {item?.participant?.gender || "--"}
                                                </span>
                                                <span>DOB | {item?.participant?.dob ? moment(item?.participant?.dob).format('Do-MMM-YYYY') : "--"}</span>
                                              </div>
                                            </div>
                                            <span className="tb-sub"></span>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <span className="tb-sub">{item?.promotion_participant?.inserted_at ? moment(item?.promotion_participant?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                          </DataTableRow>
                                          <DataTableRow>
                                            <div className="user-card">
                                              <div className="user-info">
                                                <span className="tb-lead">
                                                  <span className="tb-odr-status">
                                                    <Badge
                                                      color={
                                                        item?.promotion_participant?.status === app_consts.ACTIVE
                                                          ? "success"
                                                          : "warning"
                                                      }
                                                      className="badge-dot"
                                                    >
                                                      {item?.promotion_participant?.status ? formatToSentenceCase(item?.promotion_participant?.status)?.toUpperCase() : "--"}
                                                    </Badge>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </DataTableRow>
                                          <DataTableRow className="nk-tb-col-tools">
                                            <div className="tb-odr-btns d-none d-sm-inline">
                                              <Button color="primary" size="sm" className="btn btn-dim">
                                                View
                                              </Button>
                                            </div>
                                            <Button className="btn-pd-auto d-sm-none">
                                              <Icon name="chevron-right"></Icon>
                                            </Button>
                                          </DataTableRow>
                                        </DataTableItem>
                                      ))
                                      :
                                      <>
                                        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"Participants Not Found"} />
                                      </>
                                    }
                                  </div>
                                  {currentParticipantItems?.length > 0 && (
                                    <div className="mt-3">
                                      <PaginationComponent
                                        itemPerPage={participantItemsPerPage}
                                        totalItems={currentParticipantItems?.length}
                                        paginate={paginate}
                                        currentPage={currentParticipantItemsPage}
                                      />
                                    </div>
                                  )}
                                </Block>
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "Rules" && (
                            <>
                              <div className="card-inner bg-white">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Rules</BlockTitle>
                                  </BlockHead>
                                  <div className="profile-ud-list">
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Allow Repeat Winners</span>
                                        <span className="profile-ud-value">{page_data?.draw?.rules?.allow_repeat_winners === "true" ? "YES" : "NO"}</span>
                                      </div>
                                    </div>
                                    <div className="profile-ud-item">
                                      <div className="profile-ud wider">
                                        <span className="profile-ud-label">Max Winners</span>
                                        <span className="profile-ud-value">{page_data?.draw?.rules?.max_winners || "--"}</span>
                                      </div>
                                    </div>
                                  </div>
                                </Block>
                              </div>

                            </>
                          )
                        }
                        {
                          activeCardTab === "Prize Winners" && (
                            <>
                              <div className="card-inner bg-white">
                                <Block>
                                  <BlockHead>
                                    <BlockTitle tag="h5">Prize Winners</BlockTitle>
                                  </BlockHead>
                                  <BlockBetween>
                                    <BlockHeadContent>
                                    </BlockHeadContent>
                                    <BlockHeadContent>
                                      <div className="toggle-wrap nk-block-tools-toggle">
                                        <Button
                                          className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                                          onClick={() => updateSm(!sm)}
                                        >
                                          <Icon name="menu-alt-r"></Icon>
                                        </Button>
                                        <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                                          <ul className="nk-block-tools g-3">
                                            {page_data?.winners?.length > 0 && (
                                              <li>
                                                <Button color="primary" className="btn-primary" onClick={export_prize_winners_to_csv}>
                                                  <Icon name="download-cloud"></Icon>
                                                  <span>Export to CSV</span>
                                                </Button>
                                              </li>
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </BlockHeadContent>
                                  </BlockBetween>
                                  {
                                    page_data?.winners?.length > 0
                                      ?
                                      <>
                                        <div className="nk-tb-list is-separate is-medium mb-3">
                                          <DataTableHead className="nk-tb-item">
                                            <DataTableRow>
                                              <span className="sub-text">Name</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="sub-text">Contact</span>
                                            </DataTableRow>
                                            <DataTableRow>
                                              <span className="sub-text">Code</span>
                                            </DataTableRow>
                                            <DataTableRow size="lg">
                                              <span className="sub-text">Place/Location</span>
                                            </DataTableRow>
                                            <DataTableRow size="lg">
                                              <span className="sub-text">Gender</span>
                                            </DataTableRow>
                                            <DataTableRow size="lg">
                                              <span className="sub-text">Entry Date</span>
                                            </DataTableRow>
                                            <DataTableRow size="lg">
                                              <span className="sub-text">Prize Won</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Status</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Action</span>
                                            </DataTableRow>
                                          </DataTableHead>
                                          {page_data?.winners?.map((item) => (
                                            <DataTableItem key={item.id}>
                                              <DataTableRow>
                                                <span className="tb-product">
                                                  <span className="tb-sub">{item?.participant?.first_name ? `${item?.participant?.first_name} ${item?.participant?.middle_name ? item?.participant?.middle_name : ""} ${item?.participant?.last_name ? item?.participant?.last_name : ""}` : "--"}</span>
                                                </span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">
                                                      {item?.participant?.mobile_number || "--"}
                                                    </span>
                                                    <span>EMAIL | {item?.participant?.email_address ? item?.participant?.email_address : "--"}</span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">{item?.promotion_participant?.entry_code}</span>
                                                    <span>
                                                      <Badge
                                                        color={
                                                          item?.promotion_participant?.code_status === app_consts.VALID
                                                            ? "success"
                                                            : "warning"
                                                        }
                                                        className="badge-dot"
                                                      >
                                                        {item?.promotion_participant?.code_status ? formatToSentenceCase(item?.promotion_participant?.code_status)?.toUpperCase() : "--"}
                                                      </Badge>
                                                    </span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">
                                                      {item?.promotion_participant?.place || "--"}
                                                    </span>
                                                    <span>{item?.promotion_participant?.location || "--"}</span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">
                                                      {item?.participant?.gender || "--"}
                                                    </span>
                                                    <span>DOB | {item?.participant?.dob ? moment(item?.participant?.dob).format('Do-MMM-YYYY') : "--"}</span>
                                                  </div>
                                                </div>
                                                <span className="tb-sub"></span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <span className="tb-sub">{item?.promotion_participant?.inserted_at ? moment(item?.promotion_participant?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <span className="tb-sub">{item?.promotion_draw_winner?.prize || "--"}</span>
                                              </DataTableRow>
                                              <DataTableRow>
                                                <div className="user-card">
                                                  <div className="user-info">
                                                    <span className="tb-lead">
                                                      <span className="tb-odr-status">
                                                        <Badge
                                                          color={
                                                            item?.promotion_draw_winner?.status === app_consts.COLLECTED
                                                              ? "success"
                                                              : "warning"
                                                          }
                                                          className="badge-dot"
                                                        >
                                                          {item?.promotion_draw_winner?.status ? formatToSentenceCase(item?.promotion_draw_winner?.status)?.toUpperCase() : "--"}
                                                        </Badge>
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </DataTableRow>
                                              <DataTableRow className="nk-tb-col-tools">
                                                <div className="tb-odr-btns d-none d-sm-inline">
                                                  <Button color="primary" size="sm" className="btn btn-dim">
                                                    View
                                                  </Button>
                                                </div>
                                                <Button className="btn-pd-auto d-sm-none">
                                                  <Icon name="chevron-right"></Icon>
                                                </Button>
                                              </DataTableRow>
                                            </DataTableItem>
                                          ))
                                          }
                                        </div>
                                      </>
                                      :
                                      <>
                                        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Prize Winners Found"} />
                                      </>
                                  }
                                </Block>
                              </div>
                            </>
                          )
                        }
                        <InitiatePromotionDrawModal tenant_info={tenant_info} user_info={user_info} isOpen={initiate_promotion_draw_modal} closeModal={close_initiate_promotion_draw_modal} data={page_data} successFunction={initiate_promotion_draw_modal_successFunciton} />
                      </Row>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewPromotionDrawDetailsModal;